import React, { useEffect, useState } from 'react';
import { Maximize, WifiOff } from 'lucide-react';
import { PURPLE } from './pulseUtils';

const Clock = () => {
  const [now, setNow] = useState(new Date());
  useEffect(() => { const t = setInterval(() => setNow(new Date()), 1000); return () => clearInterval(t); }, []);
  return (
    <div className="text-right leading-none" data-testid="pulse-clock">
      <div className="text-[34px] font-semibold text-[#2b2430]" data-testid="pulse-date">
        {now.toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' })}
      </div>
      <div className="text-[64px] font-extrabold mt-2" style={{ color: PURPLE }} data-testid="pulse-time">
        {now.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' })}
      </div>
    </div>
  );
};

export const PulseHeader = ({ offline, onFullscreen, showFullscreen }) => (
  <header className="flex items-center h-[126px] px-2">
    <img src="/myhelp-logo.png" alt="MyHELP CRM" className="h-[92px] w-auto" data-testid="pulse-logo" />
    <div className="w-[3px] h-[96px] mx-12 rounded" style={{ background: PURPLE }} />
    <h1 className="text-[100px] font-semibold tracking-tight leading-none flex items-center" data-testid="pulse-title">
      <span className="text-[#2b2430]">TEAM&nbsp;</span><span style={{ color: PURPLE }}>PULSE</span>
      <svg viewBox="440 105 1120 1125" className="h-[76px] w-auto ml-5" aria-hidden="true" data-testid="pulse-heartbeat-icon">
        <polyline points="488,669 666,667 721,472 819,924 926,152 1073,1182 1180,409 1277,862 1332,664 1513,664"
          fill="none" stroke={PURPLE} strokeOpacity="0.18" strokeWidth="48" strokeLinecap="round" strokeLinejoin="round" />
        <polyline className="pulse-heartbeat-trace" pathLength="1" points="488,669 666,667 721,472 819,924 926,152 1073,1182 1180,409 1277,862 1332,664 1513,664"
          fill="none" stroke={PURPLE} strokeWidth="48" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </h1>
    <div className="flex-1" />
    <div className="flex items-center gap-5">
      {offline && (
        <span className="flex items-center gap-2 text-[18px] font-semibold text-[#c2410c] bg-[#fff1e6] rounded-full px-4 py-2" data-testid="pulse-offline-badge">
          <WifiOff size={20} />Reconnecting…
        </span>
      )}
      {showFullscreen && (
        <button type="button" onClick={onFullscreen} className="p-3 rounded-xl text-[#922A8C] hover:bg-[#f6e9f5] transition-colors" aria-label="Full screen" data-testid="pulse-fullscreen-btn">
          <Maximize size={28} />
        </button>
      )}
      <Clock />
    </div>
  </header>
);
